var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMdiUnlocked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mdi:unlocked"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.0586 5.5C12.3901 5.5 12.7081 5.6317 12.9425 5.86612C13.1769 6.10054 13.3086 6.41848 13.3086 6.75V13C13.3086 13.3315 13.1769 13.6495 12.9425 13.8839C12.7081 14.1183 12.3901 14.25 12.0586 14.25H4.55859C4.22707 14.25 3.90913 14.1183 3.67471 13.8839C3.44029 13.6495 3.30859 13.3315 3.30859 13V6.75C3.30859 6.41848 3.44029 6.10054 3.67471 5.86612C3.90913 5.6317 4.22707 5.5 4.55859 5.5H10.1836V4.25C10.1836 3.75272 9.98605 3.27581 9.63442 2.92417C9.28279 2.57254 8.80587 2.375 8.30859 2.375C7.81131 2.375 7.3344 2.57254 6.98277 2.92417C6.63114 3.27581 6.43359 3.75272 6.43359 4.25H5.18359C5.18359 3.4212 5.51283 2.62634 6.09889 2.04029C6.68494 1.45424 7.47979 1.125 8.30859 1.125C8.71897 1.125 9.12534 1.20583 9.50448 1.36288C9.88362 1.51992 10.2281 1.75011 10.5183 2.04029C10.8085 2.33047 11.0387 2.67497 11.1957 3.05411C11.3528 3.43326 11.4336 3.83962 11.4336 4.25V5.5H12.0586ZM8.30859 11.125C8.64011 11.125 8.95806 10.9933 9.19248 10.7589C9.4269 10.5245 9.55859 10.2065 9.55859 9.875C9.55859 9.54348 9.4269 9.22554 9.19248 8.99112C8.95806 8.7567 8.64011 8.625 8.30859 8.625C7.97707 8.625 7.65913 8.7567 7.42471 8.99112C7.19029 9.22554 7.05859 9.54348 7.05859 9.875C7.05859 10.2065 7.19029 10.5245 7.42471 10.7589C7.65913 10.9933 7.97707 11.125 8.30859 11.125Z",
    fill: "#F7F8FC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiUnlocked);
export default __webpack_public_path__ + "static/media/mdi_unlocked.fa6e476918122d63176162b64f60a87c.svg";
export { ForwardRef as ReactComponent };